import { useMutation, UseMutationOptions } from 'react-query';
import { defaultApi } from 'src/api';

import { CreateNewPasswordFormData } from '../types/User';

const useCreateNewPasswordMutation = (
  options?: UseMutationOptions<boolean, unknown, CreateNewPasswordFormData>
) => {
  return useMutation<boolean, unknown, CreateNewPasswordFormData>(async formData => {
    try {
      await defaultApi.post('/create-new-password', {
        email: formData.email,
        password: formData.newPassword,
        token: formData.token,
      });
      return true;
    } catch {
      return false;
    }
  }, options);
};

export default useCreateNewPasswordMutation;
